import { Pipe, PipeTransform } from '@angular/core';
import { AssetDetail } from 'src/app/modules/standard/v1';
import { PreviewMode, UtilityService } from '../services/utility.service';

// Pure pipe: the cache-busted url is recomputed only when the facing asset reference changes
// (i.e. on a data reload), not on every change detection cycle.
@Pipe({ name: 'offerPreview' })
export class OfferPreviewPipe implements PipeTransform {
  constructor(private utilityService: UtilityService) { }

  transform(facingAsset: AssetDetail, mode: PreviewMode = PreviewMode.Thumbnail): string {
    return this.utilityService.getOfferPreviewUrl(facingAsset, mode, true);
  }
}
